<template>
  <div class="Site IndexBox">
  	<van-nav-bar
			fixed
		  :border="false"
		  :title="$docTitle"
		  @click-left="InitData.link.length?$router.push('/line'):false"
		  @click-right="$langList.length>1?$router.push('/language'):false"
		>
			<template v-if="InitData.link.length" #left>
		    <van-icon :name="`./static/icon/${Theme}/icon-line.svg`" />
		  </template>
			<template v-if="$langList.length>1" #right>
		    <van-icon :name="`./static/icon/${Theme}/icon-language.svg`" />
		  </template>
		</van-nav-bar>
		<div class="ScrollBox">
			<van-swipe v-if="InitData.homebannerList.length" :autoplay="3000" indicator-color="#fff" style="height: 8.5rem;margin: 10px 15px;border-radius: 10px;z-index:3">
			  <van-swipe-item v-for="(item,index) in InitData.homebannerList" :key="index" @click="openUrl(item)">
					<img :src="InitData.setting.up_url+item.img_path" width="100%" height="100%">
			  </van-swipe-item>
			</van-swipe>
			<div v-if="InitData.homebannerList.length" class="box-shadow"></div>
			<van-cell v-if="InitData.noticelist.length" class="Broadcast" :border="false" to="/serviceCenter/1">
				<template #icon>
					<van-icon name="volume-o" size="16" color="var(--color-active)" style="margin-right: 5px" />
				</template>
				<van-swipe :show-indicators="false" vertical :autoplay="3000" style="height:14px">
				  <van-swipe-item v-for="(item,index) in InitData.noticelist" :key="index">
				  	<div style="max-height:14px" v-html="item.content"></div>
				  </van-swipe-item>
				</van-swipe>
			</van-cell>
			<van-grid class="menu" icon-size="48" :border="false">
			  <van-grid-item v-for="item,index in InitData.homeNavList" :key="index" :icon="InitData.setting.up_url+item.cover_img" :text="item.title" @click="openNav(item.url,item.id)" />
			</van-grid>
			<a v-for="item,index in InitData.activitybannerList" :key="'activity'+index" class="promote" href="javascript:;" @click="openUrl(item)">
				<img :src="`${InitData.setting.up_url}${item.img_path}`" width="100%" style="display: block;">
			</a>
			<!-- <div v-if="InitData.setting.company_video" class="group">
				<div class="title">
					{{$t('home.title[0]')}}
				</div>
				<video-player
					class="vjs-custom-skin"
					ref="videoPlayer"
					:playsinline="true"
					:options="playerOptions"
					@play="onPlayerPlay($event)"
					@pause="onPlayerPause($event)"
					@ended="onPlayerEnded($event)"
					@loadeddata="onPlayerLoadeddata($event)"
					@waiting="onPlayerWaiting($event)"
					@playing="onPlayerPlaying($event)"
					@timeupdate="onPlayerTimeupdate($event)"
					@canplay="onPlayerCanplay($event)"
					@canplaythrough="onPlayerCanplaythrough($event)"
					@ready="playerReadied"
					@statechanged="playerStateChanged($event)"
				/>
			</div> -->
			<!-- <div class="group">
				<div class="title" style="padding:0">
					{{$t('home.title[1]')}}
				</div>
				<div class="vip-group">
					<ul>
						<li v-for="item,index in InitData.UserGradeList.slice(0,3)" :key="index" :class="{active:item.grade==UserInfo.vip_level}" @click="UserInfo?false:$router.push('/login')">
							<i v-if="item.grade==UserInfo.vip_level" class="tips">{{$t('vip.user.title[0]')}}</i>
							<div>
								<div class="title">
									<van-icon :name="`./static/icon/icon-vip.png`" />
									{{item.name}}
								</div>
								<div class="num" v-html="$t('vip.list.label',{number: item.number})"></div>
								<div v-if="item.commission" class="inc">{{$t('vip.list.text[4]')}} {{InitData.currency}}{{$Util.MoneyFormat(item.commission)}}</div>
								<div v-if="item.grade==UserInfo.vip_level" class="inc">
									{{$t('vip.user.value[4]')}} {{UserInfo.vip_level==1?`${InitData.setting.memberday}${$t('vip.user.value[3]')}`:$Util.DateFormat('YY-MM-DD',UserInfo.etime)}}
								</div>
								<div v-else class="inc">
									{{$t('vip.user.value[0]')}} {{item.days}}{{$t('vip.user.value[3]')}}
								</div>
							</div>
							<div v-if="UserInfo" class="btn">
								<van-button v-if="item.grade!=1" type="danger" round size="mini" @click="submitBuy(item.amount,item.grade,item.name)">{{item.grade==UserInfo.vip_level?$t('vip.list.button[1]'):$t('vip.list.button[0]')}}</van-button>
							</div>
							<div v-else class="btn">
								<span>{{$t('vip.user.title[1]')}}</span>
							</div>
						</li>
						<li @click="$router.push('/vip')" style="align-items:center;justify-content:center">
							<span>{{$t('vip.more')}}<van-icon name="arrow" /></span>
						</li>
					</ul>
				</div>
			</div> -->
			<div ref="pageDom" v-for="item,index in InitData.homePage" :key="index" v-html="item.content"></div>
		</div>
		{{InitData.setting.homeData}}
		<Footer />
		<van-popup v-model="showNotice" style="background: transparent;width: 85%;text-align: center;height: 80%" @closed="closeNotice">
			<dl class="NoticePopup" v-if="noticeData">
				<dt>{{$t('home.noticeTitle')}}</dt>
				<dd v-html="noticeData.content"></dd>
				<dt v-if="noticeData.url" style="padding:0"><a class="chat" href="javascript:;" @click="$Util.OpenUrl(noticeData.url.split(',')[0])">{{noticeData.url.split(',')[1]}}</a></dt>
			</dl>
			<a class="close" href="javascript:;" @click="showNotice=false"><van-icon name="clear" color="rgba(255,255,255,.8)" size="2.2rem" /></a>
		</van-popup>
		<van-popup v-model="showActivity" style="background: transparent;width: 85%;text-align: center;" @closed="closeActivity">
			<dl v-if="activityData" class="NoticePopup" style="background: #fff;">
				<dt style="color:#000;text-align:center;padding:20px">{{activityData.title}}</dt>
				<dd>{{activityData.description}}</dd>
				<dt style="padding:0">
					<a class="chat" href="javascript:;" @click="openActivity(activityData)">{{$t('Activity[2]')}}</a>
				</dt>
			</dl>
			<a class="close" href="javascript:;" @click="showActivity=false"><van-icon name="clear" color="rgba(255,255,255,.8)" size="2.2rem" /></a>
		</van-popup>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.min.css'
export default {
  name: 'Home',
  inject: ['reloadHtml'],
  components: {
    
  },
  props: [],
  
  data() {
    return {
    	showNotice: false,
    	activeTabs: 0,
    	mySwiper: null,
    	caseSwiper: null,
    	showActivity: false,
    	activityIndex: 0,
    }
  },
  
  computed: {
  	player() {
      return this.$refs.videoPlayer.player
    },
    playerOptions() {
    	return {
    		controls: false,
        aspectRatio: '16:9',
			  sources: [{
          type: "video/mp4",
          src: this.$store.state.InitData.setting.company_video
        }]
      }
		},
		noticeData() {
			if(this.$store.state.InitData.noticelist.length){
				this.showNotice = true
	  		return this.$store.state.InitData.noticelist[0]
	  	}else{
	  		this.showNotice = false
	  		return ''
	  	}
		},
		activityData() {
			if(this.$store.state.InitData.popupActivity.length){
				if(this.activityIndex<this.$store.state.InitData.popupActivity.length){
					return this.$store.state.InitData.popupActivity[this.activityIndex]
				}else{
					return ''
				}
	  	}
		},
  },
  watch: {
  	'InitData.homePage'(data){
  		if(!this.$refs.pageDom){
  			this.startSwiper()
  		}
  	},
  },
  created() {

  },
  mounted() {
  	if(this.$refs.pageDom){
  		this.startSwiper()
  	}
  	// if(this.$store.state.InitData.memberList&&this.$store.state.InitData.memberList.length){
  	// 	this.$nextTick(()=>{
  	// 		const data = $('#SwipeList1 .van-swipe-item').slice(0, 10)
  	// 		for (var i = 0; i < data.length; i++) {
  	// 			$('#SwipeList1').children().append($(data[i])[0].outerHTML)
  	// 		}
  	// 	})
  	// }
  	// if(this.$store.state.InitData.businessList&&this.$store.state.InitData.businessList.length){
  	// 	this.$nextTick(()=>{
  	// 		const data = $('#SwipeList2 .van-swipe-item').slice(0, 10)
  	// 		for (var i = 0; i < data.length; i++) {
  	// 			$('#SwipeList2').children().append($(data[i])[0].outerHTML)
  	// 		}
  	// 	})
  	// }
  },
  activated() {

  },
  destroyed() {

  },
  methods: {
  	closeActivity() {
  		this.activityIndex+=1
  		if(this.activityData){
  			this.showActivity = true
  		}else{
  			this.showActivity = false
  		}
  	},
  	closeNotice() {
  		if(this.activityData){
  			this.showActivity = true
  		}else{
  			this.showActivity = false
  		}
  	},
  	openUrl(data){
      if(data.url){
        if(data.urltype=='w'){
          this.$Util.OpenUrl(data.url)
        }else{
        	this.$router.push(data.url)
        }
      }else{
        return false
      }
    },
  	startSwiper(){
  		this.$nextTick(()=>{
				const logoLen = $('.logo__wrap').length
		  	this.mySwiper = new Swiper('#logoSwiper', {
		  		loop: true,
		  		autoplay: {
		  			delay: 5000
		  		},
		  		on: {
				    slideChange: function(){
				      let index = this.activeIndex==logoLen+1?1:this.activeIndex
				      index = this.activeIndex?index:logoLen-index
			      	const length = logoLen+1-index
			      	for (var i = length; i < logoLen; i++) {
			      		$('.logo__wrap[data-id="'+i+'"]').attr('data-order',i-length)
			      	}
			      	for (var i = 0; i < length; i++) {
			      		$('.logo__wrap[data-id="'+i+'"]').attr('data-order',i+index-1)
			      	}
				    },
				  },
		  	});
		  	this.caseSwiper = new Swiper('#caseSwiper', {
		  		loop: true,
		  		pagination: {
			      el: '.swiper-pagination',
			    },
		  	});

		  	if(this.$store.state.InitData.setting.homeData.length){
		  		this.$store.state.InitData.setting.homeData.forEach((item,index)=>{
		  			$('.case-info .number [data-ctr="'+index+'"]').text(`${item[0]}%`)
		  			$('.case-info .number [data-price="'+index+'"]').text(item[1])
		  		})
		  	}
	  	})
  	},
  	// listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    onPlayerEnded(player) {
      // console.log('player ended!', player)
    },
    onPlayerLoadeddata(player) {
      // console.log('player Loadeddata!', player)
    },
    onPlayerWaiting(player) {
      // console.log('player Waiting!', player)
    },
    onPlayerPlaying(player) {
      // console.log('player Playing!', player)
    },
    onPlayerTimeupdate(player) {
      // console.log('player Timeupdate!', player.currentTime())
    },
    onPlayerCanplay(player) {
      // console.log('player Canplay!', player)
    },
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
    // player is ready
    playerReadied(player) {
      console.log('player readied')
    },
    submitBuy(amount,grade,name) {
      const currAmount = Number(this.InitData.UserGradeList.find(item=>item.grade==this.UserInfo.vip_level).amount)
      if(this.UserInfo.vip_level>grade){
        this.$toast.fail(this.$t('vip.dialog[1]',{currname: this.UserInfo.useridentity,name: name}))
      }else{
        let html = ""
        if(this.UserInfo.vip_level==grade){
          html = this.$t('vip.dialog[2]',{currency: this.InitData.currency,amount: this.$Util.MoneyFormat(amount),name: name})
        }else{
          if(this.InitData.setting.is_ck==1){
            amount = Number(amount)-currAmount
          }
          html = this.$t('vip.dialog[0]',{currency: this.InitData.currency,amount: this.$Util.MoneyFormat(amount),name: name})
        }
        this.$Dialog.Confirm(html,()=>{
          this.$Model.BuyVip({grade:grade},data=>{
            if(data.code==1){
              this.$Model.GetUserInfo()
            }
            if(data.code==2){
              this.$router.push(`/user/recharge?amount=${Number(data.amount||amount)}`)
            }
          })
        })
      }
    },
    goTask(index,state) {
    	if(state==3){
    		this.$toast.fail(this.$t('home.msg'))
    	}else{
    		this.$router.push(`/task/${index}`)
    	}
    },
    goPost(id) {
    	this.$router.push({name: 'postTask', query:{type:id}})
    },
    openNav(url,id) {
    	if(url){
    		if(url.indexOf('article')!==-1){
    			if(url.indexOf('video')!==-1){
		    		this.openVideo()
		    	}else{
		    		this.$router.push(`${url}/${id}`)
		    	}
    		}else{
    			if(url.indexOf('/vip')!==-1&&this.$store.state.InitData.setting.vip_open!=1){
    				this.$Dialog.Toast(this.$t('dialog[11]'))
    				return
    			}
    			if(url.indexOf('/user/recharge')!==-1&&this.$store.state.InitData.setting.recharge_open!=1){
    				this.$Dialog.Toast(this.$t('dialog[12]'))
    				return
    			}
    			this.$router.push(url)
    		}
    	}else{
    		this.$Dialog.Toast(this.$t('dialog[7]'))
    	}
    },
    openVideo() {
    	if(this.$store.state.InitData.videovTutorial.length>1){
    		this.$router.push(`/article/video`)
    	}else{
    		this.$router.push(`/article/video/${this.$store.state.InitData.videovTutorial[0].id}`)
    	}
    },
    // openMedia() {
    // 	if(this.InitData.cooperativeMedia.length){
    // 		this.$router.push(`/article/media/${this.InitData.cooperativeMedia[0].id}`)
    // 	}else{
    // 		this.$Dialog.Toast(this.$t('home.tips'))
    // 	}
    // },
    // openCompany() {
    // 	if(this.InitData.companyStrength.length){
    // 		this.$router.push(`/article/company/${this.InitData.companyStrength[0].id}`)
    // 	}else{
    // 		this.$Dialog.Toast(this.$t('home.tips'))
    // 	}
    // },
    openActivity(data){
      if(data.url&&!data.is_iframe){
        if(data.urltype=='w'){
          this.$Util.OpenUrl(data.url)
        }else{
          this.$router.push(data.url)
        }
      }else{
        this.$router.push(`/activityDetail/${data.id}`)
      }
    }
  }
}
</script>
<style scoped>
.van-nav-bar>>>.van-nav-bar__title{
	max-width: 50%;
}
.van-nav-bar>>>.van-nav-bar__left,.van-nav-bar>>>.van-nav-bar__right{
	max-width: 25%;
}
.Broadcast{
	padding: 6px 12px;
	line-height: 1;
	margin: 20px 15px 15px;
	background-color: var(--background-theme);
	border-radius: 10px;
	width: auto;
}
.Broadcast .van-swipe-item{
	overflow: hidden;
	display: flex;
	align-items: center;
	color: var(--color-active);
}
.Broadcast .van-swipe-item>div{
	display: flex;
}
.Broadcast .van-swipe-item>div>>>*{
	font-size: 14px!important;
	color: var(--color-active)!important;
	white-space: nowrap;
}
.menu>>>.van-grid-item__text{
	font-size: 13px;
	color: var(--color-main);
}
.TaskHall>>>.van-grid-item__content{
	padding: 10px 22px;
	justify-content: flex-start;
	text-align: justify;
	border-radius: 5px;
}
.TaskHall>>>.van-grid-item__icon-wrapper{
	margin-right: 10px;
	flex: 1;
	text-align: left;
}
.MemberList{
	overflow: hidden;
	padding: 0 15px;
	margin-bottom: 20px;
}
.MemberList>>>.van-tab{
	padding: 0;
	flex: none;
}
.MemberList>>>.van-tab+.van-tab{
	margin-left: 20px;
}
.MemberList>>>.van-tab--active .van-tab__text{
	font-size: 18px;
}
.topItem {
	line-height: 1;
	padding: 12px 0;
	border-bottom: 3px #fff solid;
	overflow: unset;
}
.vip1{
	background: linear-gradient(to right,#fbeed8,transparent);
}
.vip2{
	background: linear-gradient(to right,#d6e4fc,transparent);
}
.vip3{
	background: linear-gradient(to right,#fad5d5,transparent);
}
.topItem .num{
	font-weight: 600;
	color: var(--color-assist);
	margin-right: 15px;
	width: 16px;
	position: unset;
}
.vip1 .num img,.vip2 .num img,.vip3 .num img{
	width: 32px;
	height: auto;
	position: absolute;
	top: -2px;
	left: -2px;
}
.topItem .head{
	border-radius: 100%;
	overflow: hidden;
	border: 2px #e6e5e8 solid;
	margin-right: 10px;
}
.topItem .van-cell__title{
	font-size: 15px;
	font-weight: 600;
}
.topItem .van-cell__label{
	line-height: 1;
	margin-top: 8px;
	font-weight: 400;
}
.topItem .profit{
	display: flex;
	align-items: center;
	font-size: 14px;
	margin-left: 10px;
	font-weight: 600;
}
.topItem .profit img{
	margin-right: 5px;
}

.Title{
	margin: 4px 0;
	padding: 7px 25px;
}
.box-shadow {
	height: 5px;
	box-shadow: 0 4px 10px #ea6b5d;
	margin: -15px 25px 0;
	position: relative;
	z-index: 2;
}
.menu{
	margin: 0 7px;
}
.menu>>>.van-grid-item__text{
	font-weight: 600;
}
.promote{
	margin: 15px;
	display: block;
	border-radius: 10px;
	overflow: hidden;
}
.group{
	padding: 15px;
	line-height: 1;
}
.group>.title{
	font-size: 18px;
	font-weight: 600;
	padding-bottom: 12px;
}
.vip-group{
	margin-right: -10px;
}
.vip-group ul{
	display: flex;
	flex-wrap: wrap;
}
.vip-group ul li{
	background-color: var(--background-theme);
	width: calc((100vw - 40px)/2);
	padding: 10px;
	position: relative;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin: 10px 10px 0 0;
}
.vip-group ul li.active:before{
	left: 2px;
	right: 2px;
	top: 2px;
	bottom: 2px;
}
.vip-group ul li:before,.vip-group ul li:after{
	content: '';
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-color: var(--background-theme);
	z-index: 2;
	border-radius: 10px;
}
.vip-group ul li:after {
	background: linear-gradient(#fbf7c0, #fdc2a2);
	z-index: 1;
}
.vip-group ul li>*{
	position: relative;
	z-index: 3;
}
.vip-group ul li .title{
	display: flex;
	align-items: center;
	font-size: 14px;
	font-weight: 600;
}
.vip-group ul li .title .van-icon{
	margin-right: 3px;
}
.vip-group ul li .num{
	margin-top: 8px;
}
.vip-group ul li .num>>>b{
	font-size: 20px;
	margin: 0 3px;
}
.vip-group ul li .inc{
	margin-top: 3px;
	color: var(--color-assist);
	font-size: 12px;
}
.vip-group ul li .btn{
	margin-top: 15px;
	display: flex;
	align-items: center;
}
.vip-group ul li .btn>span{
	color: var(--color-assist);
}
.vip-group ul li .tips{
	position: absolute;
	background-color: var(--background-vip-tag);
	color: white;
	right: -8px;
	font-size: 12px;
	padding: 3px 5px;
	border-radius: 5px 5px 5px 0;
	top: -8px;
}

</style>